<template>
	<div class="main-contents">
		<div class="package">
			<div class="table">
				<div class="list-box">
					<div v-if="corpdiv == '31'" class="tit">내 IT프로 &gt; 지원 프로젝트</div>
					<div v-else class="tit">지원 IT프로</div>
					<div class="search-box interval">
						<div class="box-line">
							<SelectComp type="select" title="프로젝트 상태" list="2:수행예정,1:수행중,9:수행완료" :isAll="true" v-model="srchFilter.projectStatus" /><nbsp/>
							<SelectComp type="select" title="프로젝트명" list="1:프로젝트명,4:고객사명" v-model="srchFilter.searchGubun" />						
							<InputComp type="text" :placeholder="srchFilter.searchGubun ==  '1' ? '프로젝트명' : '고객사명'" v-model="srchFilter.searchKeyword" @keyup.enter="getDcoPgmPrjAppPrjList('1')" />
							<div class="search_btn" @click="getDcoPgmPrjAppPrjList('1')" >
								<img class="search" src="/images/icon_srch.png" alt="검색버튼"/>
							</div>
							<!-- <img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getDcoPgmPrjAppPrjList('1')"/> -->
						</div>
					</div>
					<div class="filter">
						<div class="filter_box"> 
							<ul>
								<li @click="changeOrderGubun('1')"><img src="/images/icon_filter.png" alt="최신 등록순" :class="srchFilter.orderGubun == '1' ? 'filter' : ''"/><p>최신 등록순</p><span>ㅣ</span></li>
								<li @click="changeOrderGubun('2')"><img src="/images/icon_filter.png" alt="지원 적은순" :class="srchFilter.orderGubun == '2' ? 'filter' : ''"/><p>지원 적은순</p><span>ㅣ</span></li>
								<li @click="changeOrderGubun('3')"><img src="/images/icon_filter.png" alt="지원 많은순" :class="srchFilter.orderGubun == '3' ? 'filter' : ''"/><p>지원 많은순</p><span>ㅣ</span></li>
								<li @click="changeOrderGubun('4')"><img src="/images/icon_filter.png" alt="마감 임박순" :class="srchFilter.orderGubun == '4' ? 'filter' : ''"/><p>마감 임박순</p></li>
							</ul>
						</div>
					</div>

					<div class="Board type3">
						<table class="Board_type3 prj list-all" style="margin-left: 0;">
							<colgroup> 
								<col width="3%">
								<col width="*">
								<col width="12%">
								<col width="15%">
								<col width="10%">
								<col width="10%">
								<col width="18%">
							</colgroup>
							<thead>
								<tr>
									<th>NO</th>
									<th>프로젝트명</th>
									<th>고객사명</th>
									<th>프로젝트 기간</th>
									<th>등록일</th>
									<th>프로젝트 상태</th>
									<th>프로젝트 지원 IT프로</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(project, index) in prjList" :key="index">
									<td class="score">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}</td>
									<td class="score prj-name">
										<div v-if="project.recrEndDateDiff >= 0" class="rc_tag" >
											<div v-if="project.recrEndDateDiff >= 0" class="rc_mark">+모집중</div>
										</div>
										{{project.projectNm}}
									</td>
									<td class="score prj-name">{{project.clientNm}}</td>
									<td class="score">{{project.projectStartYyyymmdd | date('yyyy.MM.dd')}} ~ {{project.projectEndYyyymmdd | date('yyyy.MM.dd')}}</td>
									<td class="score">{{project.regYyyymmdd | date('yyyy.MM.dd')}}</td>
									<td class="score">
										<span v-if="project.projectState == 1"><div class="state pf"></div>수 행 중</span>
										<span v-if="project.projectState == 2"><div class="state ep"></div>수행예정</span>
										<span v-if="project.projectState == 9"><div class="state cp"></div>수행완료</span>
									</td>
									<td class="score resume">
										<div class="mem">{{project.appCount}}명</div>
										<div v-if="corpdiv == '31'" class="btn" style="min-width: 110px;" @click="clickProjectDetail(project)">지원 IT프로 보기 &#9654;</div>
										<div v-else class="btn" style="min-width: 110px;" @click="clickProjectDetail(project)">인터뷰 요청 &#9654;</div>
									</td>
								</tr>
								
								<!-- 등록된 프로젝트가 없을 경우 -->
								<tr v-if="prjList.length <= 0">
									<td colspan="7" class="none">프로젝트가 없습니다.</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- 페이징부분 -->
					<pagingComp :pageInfo="pageInfo" @page-click="goPage" />
				</div>
			</div>
			<!-- footer -->
			<!-- <footer-layout type="left"/> -->
		</div>
	</div>	
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';

export default {
	data() {
		return {
			pageInfo : {},
			corpdiv : this.$store.state.userInfo.mberDivCd,

			srchFilter : {
				searchKeyword : '',
				orderGubun : 1, 
				pageIndex : 1,
				// projectStatus : '',
				searchGubun : 1,
				prjEndInquiryYn : 'Y',
				prjListInqCond : this.$store.state.userInfo.mberDivCd == '31' ? 3 : 2,
				myPrjListYn : this.$store.state.userInfo.mberDivCd == '31' ? 'N' : 'Y',
			},

			prjList :[],

			nowYyyymmdd : new Date().format("yyyyMMdd"),
		}
	},

	components : {
		pagingComp
	},

	beforeMount() {
		if(this.$route.params) {
			if(this.$route.params.searchKeyword != '' && this.$route.params.searchKeyword != undefined) {
				this.srchFilter.searchKeyword = this.$route.params.searchKeyword;
			}

			if(this.$route.params.projectStatus != '' && this.$route.params.projectStatus != undefined) {
				this.srchFilter.projectStatus = this.$route.params.projectStatus;
			}

			if(this.$route.params.searchGubun != '' && this.$route.params.searchGubun != undefined) {
				this.srchFilter.searchGubun = this.$route.params.searchGubun;
			}

			if(this.$route.params.orderGubun != '' && this.$route.params.orderGubun != undefined) {
				this.srchFilter.orderGubun = this.$route.params.orderGubun;
			}
			if(this.$route.params.pageIndex != '' && this.$route.params.pageIndex != undefined) {
				this.srchFilter.pageIndex = this.$route.params.pageIndex;
			}
		}
		this.getDcoPgmPrjAppPrjList();
	},

	mounted(){
        // this.$emit('setViewConfig', {'footer': 'left', 'quickMenu':false})
    },
    destroyed(){
        this.$emit('clearViewConfig')
    },

	methods : {
		getDcoPgmPrjAppPrjList(div) {
			var param = this.srchFilter;
			param.pageUnit = 20;
			param.pageSize = 10;
			// param.corpdiv = this.corpdiv;
			if(div) this.srchFilter.pageIndex = 1;

			this.$.httpPost('/api/prj/modul/getProjectList', param)
			// this.$.httpPost('/api/prj/getProjectAppList', param)
				.then((res) => {
					// console.log(res.data);
					this.prjList = res.data.projectList;
					this.pageInfo = res.data.pageInfo;
				});
		},

		// 정렬 순서
		changeOrderGubun(orderGubun) {
			this.srchFilter.orderGubun = orderGubun;
			this.srchFilter.pageIndex = 1;
			this.getDcoPgmPrjAppPrjList();
		},

		// 페이지 이동
		goPage(page) {
			this.srchFilter.pageIndex = page;
			this.getDcoPgmPrjAppPrjList();
		},

		clickProjectDetail(project) { 
			if(this.$store.state.userInfo.mberDivCd == '31') {
				this.$router.push({name : 'PRJ403M02', params : { projectSeq : project.projectSeq , caller : { name : this.$route.name, params : this.srchFilter}}});	
			} else {
				// this.$router.push({name : 'PRJ305M02'});
				this.$router.push({name : 'PRJ305M02', params : { projectSeq : project.projectSeq , caller : { name : this.$route.name, params : this.srchFilter}}});
				// this.$router.push({name : 'PRJ302M11', params : { project : project, input : this.input ,  caller : {name : this.$route.name, params :project} }});
			}
			
		}
	}
}
</script>